import { cx } from '@linaria/core';
import { Select } from 'components/SelectV2';
import { components, GroupBase, OptionProps, SingleValueProps } from 'react-select';
import TruncatedText from 'components/TruncatedText';
import { useEffect, useState } from 'react';
import { selectWrapper } from './Dropdown.styles';

type Props = {
  className?: string;
  options: { value: string; label: string; icon: JSX.Element | null }[];
  onChange: (selectedOption: { label: string; value: string; icon: JSX.Element | null }) => void;
  defaultValue?: { value: string; label: string; icon: JSX.Element | null };
};

const Option = (
  props: JSX.IntrinsicAttributes &
    OptionProps<
      { value: string; label: string; icon: JSX.Element | null },
      boolean,
      GroupBase<{ value: string; label: string; icon: JSX.Element | null }>
    >,
) => {
  return (
    <components.Option {...props}>
      <div className="itemContainer">
        {props.data?.icon}
        <TruncatedText customContainerWidth={400} text={props.label} className={props.isSelected ? 'active' : 'option-label'} />
      </div>
    </components.Option>
  );
};

const SingleValue = (props: SingleValueProps<{ value: string; label: string; icon: JSX.Element | null }>) => (
  <div className="itemContainer">
    {props.data?.icon}
    <span className="option-label">{props.data?.label}</span>
  </div>
);

export const Dropdown: React.FC<Props> = ({ className, options, onChange, defaultValue }) => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  const onChangeHandler = (value: { label: string; value: string; icon: JSX.Element | null }) => {
    setSelectedOption(value);
    onChange(value);
  };

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue?.value]);

  return (
    <div>
      <Select
        className={cx(selectWrapper, className)}
        classNamePrefix="react-select"
        options={options}
        isSearchable={false}
        defaultValue={defaultValue ?? options[0]}
        components={{ Option, SingleValue }}
        onChange={(value) => onChangeHandler(value as { label: string; value: string; icon: JSX.Element | null })}
        isLoading={options.length === 0}
        value={selectedOption}
        aria-autocomplete="none"
      />
    </div>
  );
};
